import { IconButton } from '@fullstory/components';
import { handleInteractiveKeydown } from '@fullstory/util/a11y';
import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { useIntl } from 'react-intl';
import css from './index.module.scss';

interface ArrowProps {
  page: number;
  disabled: boolean;
  onClick?: (page: number) => void;
  icon: 'previous' | 'next';
}

export const Arrow: React.FC<ArrowProps> = ({ page, disabled, onClick, icon }) => {
  const intl = useIntl();

  const className = classNames(css.icon, {
    [css.disabled]: disabled,
  });

  const title =
    icon === 'previous'
      ? intl.formatMessage({
          defaultMessage: 'previous',
          id: 'exSggK',
          description: 'tooltip for arrow icon button to go to previous page',
        })
      : intl.formatMessage({
          defaultMessage: 'next',
          id: 'xUXTjs',
          description: 'tooltip for arrow icon button to go to next page',
        });

  return (
    <IconButton
      data-component="Arrow"
      size="small"
      data-testid={icon}
      className={className}
      disabled={disabled}
      iconName={icon === 'previous' ? 'chevron-left' : 'chevron-right'}
      onClick={() => {
        onClick?.(page);
      }}
      role="button"
      tabIndex={0}
      onKeyDown={handleInteractiveKeydown(() => onClick?.(page))}
      title={title}
      aria-disabled={disabled}
    />
  );
};
